module.exports = __webpack_public_path__ + "static/media/debug.depth.88bb38a3.frag";